<template>
  <div class="sub-account">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="搜索">
          <el-input v-model="formInline.search" placeholder="订单号/交易号/外部订单号"></el-input>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="formInline.order_id" placeholder="订单ID"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="分账状态">
          <el-select v-model="formInline.status" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="未分账" value="0"></el-option>
            <el-option label="已分账" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账类型">
          <el-select v-model="formInline.type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="分账到个人" value="PERSONAL_OPENID"></el-option>
            <el-option label="分账到商户" value="MERCHANT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="formInline.create_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-date-picker
            v-model="formInline.settle_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_sub_id" label="分账ID" width="80"></el-table-column>
          <el-table-column prop="order_no" label="订单号" width="180">
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.order_no || '--' }}</p>
                <p style="color: #999; font-size: 12px;">订单ID: {{ scope.row.order_id }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="用户信息" width="150">
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.nickName || '--' }}</p>
                <p style="color: #999; font-size: 12px;">ID: {{ scope.row.user_id }}</p>
                <p style="color: #999; font-size: 12px;">{{ scope.row.mobile || '' }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="订单金额" width="120" align="right">
            <template slot-scope="scope">
              <span>¥{{ scope.row.pay_price || '0.00' }}</span>
            </template>
          </el-table-column> 
            <el-table-column prop="pay_price" label="订单状态" width="120" align="right">
            <template slot-scope="scope">
              <span>{{ getOrderStatusText(scope.row.order_status) }}</span>
            </template>
          </el-table-column> 
            
          <el-table-column prop="sub_money" label="分账金额" width="120" align="right">
            <template slot-scope="scope">
              <span class="amount">¥{{ scope.row.sub_money || '0.00' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="act_sub_money" label="实际分账" width="120" align="right">
            <template slot-scope="scope">
              <span class="amount">¥{{ scope.row.act_sub_money || '0.00' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type_text" label="分账类型" width="100"></el-table-column>
          <el-table-column prop="status_text" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)" size="small">
                {{ scope.row.status_text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="transaction_id" label="交易号" width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.transaction_id || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="out_order_no" label="外部订单号" width="180">
            <template slot-scope="scope">
              <p>{{ scope.row.out_order_no || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="account" label="分账账户" width="150">
            <template slot-scope="scope">
              <p>{{ scope.row.account || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
          <el-table-column prop="settle_time" label="结算时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.settle_time || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="viewDetail(scope.row)" type="text" size="small">详情</el-button>
            </template> 
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--详情弹窗-->
    <el-dialog title="分账详情" :visible.sync="detailDialogVisible" width="700px">
      <div v-if="currentDetail" class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="分账ID">{{ currentDetail.order_sub_id }}</el-descriptions-item>
          <el-descriptions-item label="订单号">{{ currentDetail.order_no }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="getOrderStatusTagType(currentDetail.order_status)" size="small">
              {{ getOrderStatusText(currentDetail.order_status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="用户信息">{{ currentDetail.nickName }}(ID:{{ currentDetail.user_id }})</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ currentDetail.mobile || '--' }}</el-descriptions-item>
          <el-descriptions-item label="分账类型">{{ currentDetail.type_text }}</el-descriptions-item>
          <el-descriptions-item label="分账状态">
            <el-tag :type="getStatusTagType(currentDetail.status)" size="small">
              {{ currentDetail.status_text }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="订单金额">¥{{ currentDetail.pay_price }}</el-descriptions-item>
          <el-descriptions-item label="分账金额">¥{{ currentDetail.sub_money }}</el-descriptions-item>
          <el-descriptions-item label="实际分账">¥{{ currentDetail.act_sub_money }}</el-descriptions-item>
          <el-descriptions-item label="分账手续费">¥{{ currentDetail.sub_fee || '0.00' }}</el-descriptions-item>
          <el-descriptions-item label="分账比例">{{ (currentDetail.sub_ratio * 100) || '0' }}%</el-descriptions-item>
          <el-descriptions-item label="交易号">{{ currentDetail.transaction_id || '--' }}</el-descriptions-item>
          <el-descriptions-item label="外部订单号">{{ currentDetail.out_order_no || '--' }}</el-descriptions-item>
          <el-descriptions-item label="实际外部单号">{{ currentDetail.act_out_order_no || '--' }}</el-descriptions-item>
          <el-descriptions-item label="分账账户">{{ currentDetail.account || '--' }}</el-descriptions-item>
          <el-descriptions-item label="OpenID">{{ currentDetail.open_id || '--' }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">{{ currentDetail.pay_mode_text }}</el-descriptions-item>
          <el-descriptions-item label="描述说明">{{ currentDetail.description || '--' }}</el-descriptions-item>
          <el-descriptions-item label="备注信息">{{ currentDetail.remark || '--' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentDetail.create_time }}</el-descriptions-item>
          <el-descriptions-item label="结算时间">{{ currentDetail.settle_time || '--' }}</el-descriptions-item>
          <el-descriptions-item label="失败原因" :span="2">{{ currentDetail.fail || '--' }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      formInline: {
        search: '',
        order_id: '',
        user_id: '',
        status: '',
        type: '',
        create_time: [],
        settle_time: []
      },
      detailDialogVisible: false,
      currentDetail: null
    };
  },
  
  created() {
    this.getTableList();
  },

  methods: {
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    async getTableList() {
      this.loading = true;
      
      try {
        let params = {
          ...this.formInline,
          page: this.curPage,
          pageSize: this.pageSize
        };
        
        // 处理时间范围参数
        if (this.formInline.create_time && this.formInline.create_time.length === 2) {
          params.start_time = this.formInline.create_time[0];
          params.end_time = this.formInline.create_time[1];
        }
        
        if (this.formInline.settle_time && this.formInline.settle_time.length === 2) {
          params.settle_start = this.formInline.settle_time[0];
          params.settle_end = this.formInline.settle_time[1];
        }
        
        const res = await UserApi.getSubAccountList(params, true);
        
        if (res.code === 1) {
          this.tableData = res.data.list || [];
          this.totalDataNumber = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      } catch (error) {
        console.error('获取分账明细失败:', error);
        this.$message.error('网络错误');
      } finally {
        this.loading = false;
      }
    },

    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    onReset() {
      this.formInline = {
        search: '',
        order_id: '',
        user_id: '',
        status: '',
        type: '',
        create_time: [],
        settle_time: []
      };
      this.curPage = 1;
      this.getTableList();
    },

    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',  // 未分账
        1: 'success',  // 已分账
        2: 'danger',   // 分账失败
        3: 'info'      // 处理中
      };
      return typeMap[status] || 'info';
    },

    getOrderStatusTagType(orderStatus) {
      const typeMap = {
        10: 'primary',   // 进行中
        20: 'info',      // 已取消
        30: 'success'    // 已完成
      };
      return typeMap[orderStatus] || 'info';
    },

    getOrderStatusText(orderStatus) {
      const statusMap = {
        10: '进行中',
        20: '已取消', 
        30: '已完成'
      };
      return statusMap[orderStatus] || '未知状态';
    },

    async viewDetail(row) {
      try {
        // 如果已经有详细数据，直接使用
        if (row.order_sub_id) {
          this.currentDetail = row;
          this.detailDialogVisible = true;
        } else {
          // 如果没有详细数据，调用接口获取
          const res = await UserApi.getSubAccountDetail({
            order_sub_id: row.order_sub_id
          }, true);
          
          if (res.code === 1) {
            this.currentDetail = res.data;
            this.detailDialogVisible = true;
          } else {
            this.$message.error(res.msg || '获取详情失败');
          }
        }
      } catch (error) {
        this.$message.error('获取详情失败');
      }
    }
  }
};
</script>

<style scoped>
.amount {
  font-weight: bold;
  color: #e64340;
}

.detail-content {
  max-height: 60vh;
  overflow-y: auto;
}

.operation-buttons {
  margin-bottom: 15px;
}

.sub-account {
  padding: 20px;
  background: #fff;
}

.common-seach-wrap {
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/user/sub/index.vue